import { serviceCountLabel } from "../serviceRules";
import { serviceCountBadgeStyle, serviceSummaryStyle } from "../superAdminStyles";
import { useIndicatorServices } from "./useServices";

function serviceChipStyle(service, compact) {
    return {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        maxWidth: compact ? "220px" : "none",
        padding: compact ? "3px 8px" : "6px 10px",
        borderRadius: "999px",
        background: service.active ? "#eef2ff" : "#f3f4f6",
        border: `1px solid ${service.active ? "#c7d2fe" : "#e5e7eb"}`,
        color: service.active ? "#3730a3" : "#6b7280",
        fontSize: compact ? "11px" : "12px",
        fontWeight: 700,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    };
}

function ServiceChip({ service, compact }) {
    return (
        <span style={serviceChipStyle(service, compact)}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: service.active ? "#22c55e" : "#9ca3af", flexShrink: 0 }} />
            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{service.name}</span>
            {!compact && (
                <span style={{ color: service.mailConfigured ? "#15803d" : "#9ca3af", fontWeight: 600 }}>
                    {service.mailConfigured ? "mail OK" : "mail à configurer"}
                </span>
            )}
        </span>
    );
}

function EmptyServices({ compact }) {
    return compact ? (
        <div style={{ fontSize: "12px", color: "#9ca3af", marginTop: "4px" }}>Aucun service</div>
    ) : (
        <div style={serviceSummaryStyle}>
            <span style={serviceCountBadgeStyle}>0 service</span>
            <span style={{ color: "#64748b", fontSize: "13px" }}>Aucun service configuré pour cette pharmacie.</span>
        </div>
    );
}

export function ServiceIndicator({ pharmacyId, compact = false, services: providedServices = null }) {
    const { services, loading } = useIndicatorServices(pharmacyId, providedServices);

    if (loading) {
        return compact ? null : (
            <div style={serviceSummaryStyle}>
                <span style={{ color: "#64748b", fontSize: "13px" }}>Services en cours de chargement...</span>
            </div>
        );
    }

    if (services.length === 0) return <EmptyServices compact={compact} />;

    return (
        <div style={compact ? { display: "flex", flexWrap: "wrap", gap: "5px", marginTop: "6px" } : serviceSummaryStyle}>
            {!compact && <span style={serviceCountBadgeStyle}>{serviceCountLabel(services.length)}</span>}
            {services.map(service => <ServiceChip key={service.id} service={service} compact={compact} />)}
        </div>
    );
}
